import { render, staticRenderFns } from "./WinLayerPop.vue?vue&type=template&id=50fb8cbe"
import script from "./WinLayerPop.vue?vue&type=script&lang=js"
export * from "./WinLayerPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50fb8cbe')) {
      api.createRecord('50fb8cbe', component.options)
    } else {
      api.reload('50fb8cbe', component.options)
    }
    module.hot.accept("./WinLayerPop.vue?vue&type=template&id=50fb8cbe", function () {
      api.rerender('50fb8cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/WinLayerPop.vue"
export default component.exports